import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a86fa5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2a86fa5e&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2a86fa5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86fa5e",
  null
  
)

export default component.exports